import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

/** 떠날 때 잃는 것의 종류별 안내. upload는 아직 Draft로 저장하지 않은 업로드라 원본 파일까지 지운다. */
const COPY = {
    upload: {
        title: 'Discard this upload?',
        body: 'This document has not been saved as a draft. If you leave now, the uploaded file and its parsed data are removed. Use "Save Draft" to keep it.',
        action: 'Discard upload',
    },
    changes: {
        title: 'Leave without saving?',
        body: 'Your changes to this draft are not saved. Use "Save Draft" to keep them.',
        action: 'Leave without saving',
    },
    edit: {
        title: 'Discard your edits?',
        body: 'Your edits are not saved. The confirmed packing list stays unchanged unless you confirm again.',
        action: 'Discard edits',
    },
};

/** 검수 화면을 저장하지 않고 떠나려 할 때(X·Esc·바깥 클릭·Other document) 한 번 더 묻는다. */
export default function LeaveConfirmDialog({ kind, busy, onCancel, onConfirm }) {
    const copy = COPY[kind] ?? COPY.changes;
    return (
        <Dialog open={Boolean(kind)} onClose={() => !busy && onCancel()} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontSize: 14, color: '#003a52' }}>{copy.title}</DialogTitle>
            <DialogContent>
                <Typography sx={{ fontSize: 12 }}>{copy.body}</Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button size="small" onClick={onCancel} disabled={busy} sx={{ fontSize: 12 }}>Keep editing</Button>
                <Button size="small" variant="contained" color="error" onClick={onConfirm} disabled={busy} sx={{ fontSize: 12 }}>{copy.action}</Button>
            </DialogActions>
        </Dialog>
    );
}
